<template>
  <b-container
    v-if="tabIndex === 2"
    class="mb-5"
    fluid
  >
    <b-container fluid>
      <b-row>
        <b-col
          cols="12"
          md="6"
          class="px-1"
          order="2"
          order-md="1"
        >
          <b-form-group
            label="Search"
            label-for="filter_search"
            label-class="font-weight-bolder"
          >
            <b-input
              id="filter_search"
              v-model="tableCredential.filter.search"
              type="text"
              size="sm"
              placeholder="search here"
              debounce="1000"
              autocomplete="off"
            />
          </b-form-group>
        </b-col>
        <b-col
          cols="12"
          md="3"
          class="px-1"
          order="1"
          order-md="2"
        >
          <b-form-group
            label="Organization"
            label-for="filter_organization"
            label-class="font-weight-bolder"
          >
            <b-input
              id="filter_organization"
              v-model="tableCredential.filter.organization"
              type="text"
              size="sm"
              placeholder="no organization"
              autocomplete="off"
              disabled
            />
          </b-form-group>
        </b-col>
        <b-col
          cols="12"
          md="3"
          class="px-1"
          order="1"
          order-md="2"
        >
          <b-form-group
            label="Merchant"
            label-for="filter_merchant"
            label-class="font-weight-bolder"
          >
            <b-input
              id="filter_merchant"
              v-model="tableCredential.filter.merchant_name"
              type="text"
              size="sm"
              placeholder="no merchant"
              autocomplete="off"
              disabled
            />
          </b-form-group>
        </b-col>
      </b-row>

      <b-row
        class="mt-1"
      >
        <b-col
          cols="12"
          class="px-1"
        >
          <b-table
            ref="tableCredential"
            hover
            small
            striped
            bordered
            responsive
            show-empty
            :stacked="isMobile()"
            :per-page="tableCredential.perPage"
            :current-page="tableCredential.currentPage"
            :items="tableCredentialProvider"
            :fields="tableCredential.fields"
            :sort-by.sync="tableCredential.sortBy"
            :sort-desc.sync="tableCredential.sortDesc"
            :sort-direction="tableCredential.sortDirection"
            :filter="tableCredential.filter"
            :filter-included-fields="tableCredential.filterOn"
            :busy="tableCredential.busy"
          >
            <template #cell(index)="{ index }">
              {{ tableNumber(tableCredential, index) }}
            </template>

            <template #cell()="row">
              <div class="text-wrap text-md-nowrap">
                {{ row.value }}
              </div>
            </template>

            <template #cell(active)="{ value }">
              {{ Number(value) === 1 ? 'Yes' : 'No' }}
            </template>

            <template #table-busy>
              <div class="text-center py-5">
                <b-icon
                  icon="stopwatch"
                  font-scale="5"
                  animation="cylon"
                />
                <p class="h3 py-2">
                  <strong>Loading . . .</strong>
                </p>
              </div>
            </template>

          </b-table>
        </b-col>

        <b-col
          cols="12"
          md="6"
          class="mt-1 mb-2 px-1"
        >
          <b-select
            v-model="tableCredential.perPage"
            :options="tableCredential.pageOptions"
            size="sm"
            class="w-100 w-md-25"
          />
        </b-col>
        <b-col
          cols="12"
          md="6"
          class="d-flex justify-content-center justify-content-md-end mt-1 px-1"
        >
          <b-pagination
            v-model="tableCredential.currentPage"
            pills
            last-number
            first-number
            prev-text="Prev"
            next-text="Next"
            aria-controls="table"
            :total-rows="tableCredential.totalRows"
            :per-page="tableCredential.perPage"
          />
        </b-col>
      </b-row>
    </b-container>

  </b-container>
</template>

<script>
// import QUERY from 'lodash'
import { core } from '@/config/pluginInit'
import { SAdminCredential } from '@/services'
import formatter from '@/mixins/formatter'
import Ripple from 'vue-ripple-directive'
import misc from '@/mixins/misc'

export default {
  name: 'AdminMerchantCredentials',

  middleware: ['auth', 'admin'],

  directives: {
    Ripple
  },

  mixins: [misc, formatter],

  metaInfo: () => ({
    title: 'Credentials'
  }),

  props: {
    tabIndex: {
      type: Number,
      default: () => 2
    },
    merchant: {
      type: Object,
      default: () => ({
        id: null,
        first_name: null,
        last_name: null,
        organization: null,
        email: null,
        mobile_number: null,
        prefix: null,
        username: null,
        password: null,
        password_confirmation: null,
        source_account: null,
        api_rate_limit: null,
        fee: null,
        is_vip: 0,
        active: 1
      })
    }
  },

  data () {
    return {
      state: {
        busy: false,
        editing: false
      },
      credential: {
        merchant: this.merchant.id,
        payload: null
      },
      tableCredential: {
        perPage: 10,
        pageOptions: [10, 25, 50, 100],
        totalRows: 0,
        currentPage: 1,
        sortBy: null,
        sortDesc: false,
        sortDirection: 'asc',
        filter: {
          search: null,
          organization: this.merchant.organization,
          merchant_name: `${this.merchant.first_name} ${this.merchant.last_name}`
        },
        filterOn: [],
        busy: false,
        fields: [
          { mobile: 0, key: 'index', label: '#', class: 'text-center' },
          // { mobile: 5, key: 'action', class: 'text-center min-w-150px' },
          { mobile: 1, key: 'created_at', class: 'min-w-200px', formatter: this.dateTimeFormatter, sortable: true },
          { mobile: 2, key: 'client_key', class: 'min-w-200px' },
          { mobile: 3, key: 'client_secret', class: 'min-w-350px' },
          { mobile: 4, key: 'active', class: 'text-center min-w-150px' }
        ].sort(this.scaleOnMobile)
      }
    }
  },

  watch: {
    'merchant' (a) {
      console.log(a)
    }
  },

  mounted () {
    core.index()
  },

  methods: {

    async tableCredentialProvider ({ currentPage, perPage, sortBy, sortDesc, filter }) {
      this.tableCredential.busy = true
      return await SAdminCredential.get(
        this.objectToUrl({
          page: currentPage,
          per_page: perPage,
          sort: sortBy,
          sort_desc: sortDesc,
          filter_text: filter.search,
          filter_merchant: this.merchant.id
        })
      ).then(({ data }) => {
        this.tableCredential.totalRows = data.total_rows
        return data.items
      }).catch(() => []).finally(() => {
        this.tableCredential.busy = false
      })
    }

  }
}
</script>
